import Permisos from '@/router/permisos'

const DefaultContainerAuth = () => import('@/layouts/DefaultLayoutAuth.vue')
const ViewLogin = () => import('./Login')
const ViewRecovery = () => import('./Recovery')
const ViewActivacion = () => import('./Activacion')

const router = [
  {
    path: '/auth',
    component: DefaultContainerAuth,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: ViewLogin,
        beforeEnter: Permisos.IS_NOT_AUTENTICADO,
      },
      {
        path: 'recovery',
        name: 'Recovery',
        component: ViewRecovery,
        beforeEnter: Permisos.IS_NOT_AUTENTICADO,
      },
      {
        path: 'activacion',
        name: 'Activacion',
        component: ViewActivacion,
        beforeEnter: Permisos.IS_NOT_AUTENTICADO,
      },
    ],
  },
]

export default router
